export const getOptions = (catalogues, index) => {
  return catalogues.reduce((acc, item) => {
    const key = item.option[index]
    // eslint-disable-next-line
    if (!!key) acc[key] = key

    return acc
  }, {})
}
